goog.provide('el8.appservice.search');

goog.require('el8.util.string');
goog.require('el8.util.consts');
goog.require('el8.service.tz');
goog.require('el8.service.intervals');
goog.require('el8.uiwidget.alert');
goog.require('el8.service.infoField');
goog.require('el8.uiwidget.NewMindreader');
goog.require('el8.template.mindreader');
goog.require('el8.appshared.mindreaderOpts');


/**
 * This file is a shortcut for adding an InfoField and mindreader at the same time.
 * It is useful when you have an autocomplete without any other form fields.
 */
el8.appservice.search = (function() {

    function patientField(opts) {

        var that = {};

        var inputField = opts.inputField;
        var infoText = opts.text || 'find patient chart...';

        el8.service.infoField.addInfoField({
            field: inputField,
            infoText: infoText
        });

        var newSelectFn;
        if (opts.selectFn) {
            newSelectFn = function(event, item, mindreader) {
                opts.selectFn(event, item, mindreader);
                that.reset();
            };
        }

        var mindreaderOpts;
        if (opts.enterpriseAware) {
            mindreaderOpts = el8.appshared.mindreaderOpts.enterpriseAwarePatient({
                selectFn: newSelectFn,
                location: opts.location
            });
        } else {
            mindreaderOpts = el8.appshared.mindreaderOpts.patient({
                selectFn: newSelectFn
            });
        }

        if (!Object.prototype.hasOwnProperty.call(mindreaderOpts, 'showOnFocus')) {
          mindreaderOpts.showOnFocus = true
        }
        var mr = (new el8.uiwidget.NewMindreader(mindreaderOpts));
        mr.init(inputField);

        that.mr = mr;
        that.getSelectedId = function() {
            var item = mr.getSelectedItem();
            return item.id || null;
        };
        that.reset = function() { mr.setInputVal(''); };

        return that;
    }


	return {
        patientField: patientField
	};
})();

